export const RESEND_EMAIL_INTERVAL_SECONDS = 30;



// WEBPACK FOOTER //
// ./app/constants/resendEmailSeconds.js